const purseApi = {
  accountInfo: "/pay/clear/account/info", //获取账户信息（银行卡信息及商户信息）
  companyList: "/pay/clear/corp-list", // 获取公司列表
  checkOpenLian: "/pay/clear/corp/is-open-account", // 检查供应商是否开通清分账户
  realAmount: "/pay/clear/arrival/amount", // 获取实际到账金额（扣除手续费）
  applyWithdrawal: "/pay/clear/apply/withdraw", // 申请提现
  pursList: "/pay/clear/purse-list", // 获取公司下钱包列表
  checkCode: "/pay/clear/resend/verify/code", // 发送验证码
  confirmCash: "/pay/clear/confirm/withdraw", // 确认提现
  cashRelateInfo: "/pay/clear/bank-info", // 获取提现相关账户信息
  flagLian: "/pay/clear/corp/is-open-account", // 是否开通了清分账户
  transactionRecords: "/pay/clear/corp/purse/detail", // 交易记录
  statusFlag: "/pay/clear/check/status", // 激活 换绑手机号 换绑银行卡操作状态获取
  transactionType: "/pay/clear/corp/purse/type", // 交易类型枚举
  lianLianDetailItem: "/pay/clear/fund/list/item", // 连连交易明细查询流水详情
  papAgreeApply: "/infinity-yggdrasil/corp/agreement/pap-agree-apply", // 免密协议链接
  papAgreeModify: "/infinity-yggdrasil/corp/agreement/pap-agree-modify", // 免密协议链接
  papAgreeQuery: "/infinity-yggdrasil/corp/agreement/pap-agree-query", // 免密协议是否过期
  queryStatusFlag: "/infinity-yggdrasil/corp/exterior/clear-account/judge" //连连钱袋】判断是否激活
};

export default purseApi;



// WEBPACK FOOTER //
// ./src/service/basic/purseApiList.js